/**
 * Converts a shoe size filter option to a comma-separated string of all matching size values
 * across US, French, Italian, and generic formats
 *
 * @param {string} sizeOption - The value from SHOE_SIZE_OPTIONS (e.g., 'shoe-5-6', 'shoe-8-9')
 * @returns {string} Comma-separated string of matching shoe sizes
 */
export function getMatchingShoeSizes(sizeOption) {
  // Return empty string for 'ALL SIZES' option
  if (!sizeOption) {
    return '';
  }

  // Conversion mapping based on the chart (US to French/Italian)
  const sizeConversions = {
    '5': { fr: '36', it: '35' },
    '5_5': { fr: '36_5', it: '35_5' },
    '6': { fr: '37', it: '36' },
    '6_5': { fr: '37_5', it: '36_5' },
    '7': { fr: '38', it: '37' },
    '7_5': { fr: '38_5', it: '37_5' },
    '8': { fr: '39', it: '38' },
    '8_5': { fr: '39_5', it: '38_5' },
    '9': { fr: '40', it: '39' },
    '9_5': { fr: '40_5', it: '39_5' },
    '10': { fr: '41', it: '40' },
    '10_5': { fr: '41_5', it: '40_5' },
    '11': { fr: '42', it: '41' },
    '11_5': { fr: '42_5', it: '41_5' },
    '12': { fr: '43', it: '42' },
    '13': { fr: '44', it: '43' },
  };

  const matchedSizes = [];

  // Parse the size option
  if (sizeOption === '11+') {
    // US sizes: 11, 11.5, 12, 13 (and beyond if in conversions)
    const usSizes = ['11', '11_5', '12', '13'];
    usSizes.forEach(usSize => addSizesForRange(usSize, matchedSizes, sizeConversions));
  } else {
    addSizesForRange(sizeOption, matchedSizes, sizeConversions);
  }

  return matchedSizes.join(',');
}

/**
 * Helper function to add all size formats for a range of US sizes
 */
function addSizesForRange(usSize, matchedSizes, sizeConversions) {
  const conversion = sizeConversions[usSize];

  if (conversion) {
    // Add US format
    matchedSizes.push(`shoe-size-us-${usSize}`);

    // Add French format
    matchedSizes.push(`shoe-size-fr-${conversion.fr}`);

    // Add Italian format
    matchedSizes.push(`shoe-size-it-${conversion.it}`);

    // Add generic format (without country slug)
    matchedSizes.push(`shoe-size-${usSize}`);
  }
}
